import { Component, computed, HostListener, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { appMenu } from './menu.config';
import { BtnMain } from '../../../shared/components/btn-main/btn-main';
import { NgClass } from '@angular/common';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-menu',
  imports: [RouterLink, BtnMain, NgClass, RouterLinkActive],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu implements OnInit {
  router = inject(Router);
  authService = inject(AuthService);

  protected readonly appMenu = appMenu;
  protected isMobileMenuOpen = signal(false);

  private lastScrollY = 0;
  showMenu = true;
  isAtTop = true;

  user = this.authService.currentUser;

  ngOnInit(): void {
    // console.log(this.user());
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen.update(value => !value);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen.set(false);
  }

  onLogout() {
    this.authService.logout();
    this.router.navigate(['/']);
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const currentScroll = window.scrollY;

    // <= 8 tolera valores fraccionarios de scrollY con zoom/escalado de pantalla
    this.isAtTop = currentScroll <= 8;

    if (currentScroll > this.lastScrollY) {
      // Scroll DOWN
      this.showMenu = false;
    } else if (currentScroll < this.lastScrollY) {
      // Scroll UP
      this.showMenu = true;
    }

    this.lastScrollY = currentScroll;
  }
}
